import { defineMessages } from 'react-intl';

export default defineMessages({
    listBy: 'List Messages By:',
    noPosts: 'no posts'
});
